import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  Image,
  TypographyStylesProvider,
  Code,
  Box,
} from "@mantine/core";
import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import DocsButton from "../articlesHelpers/DocsButton"; // Import the new component
import {
  IconArrowBigDownFilled,
  IconArrowBigUpFilled,
  IconCircleMinus,
  IconClock,
  IconExchange,
  IconHistory,
} from "@tabler/icons-react";
import { JsonView, allExpanded, darkStyles } from "react-json-view-lite";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const GAURENTEED_UPTIME_CONTENT = (
  <TypographyStylesProvider>
    <p>
      Ideally we would provide Rizful Node for free, to help drive Bitcoin
      adoption around the world.
    </p>
    <p>
      The challenge however is "compute costs" -- basically servers running
      Rizful Node nodes, in the cloud.
    </p>
    <p>
      {" "}
      Each node that starts costs us a little bit, so that is why, before you
      start a new node, we ask you to pay a very small invoice -- currently 500
      satoshis (less than one Euro or Dollar). This is to prove you are human
      and not a bot trying to start lots of nodes automatically.
    </p>
    <p>
      {" "}
      If you just want to mess around with Rizful Node and use it for a couple
      of days, then that's probably all you need. Rizful Node is designed so you
      can easily delete nodes and start new ones.{" "}
    </p>
    <p>
      The only issue is if you want to use Rizful Node long-term.... like use it
      consistently to receive lightning payments, or send lightning payments.
    </p>
    <p>
      In this case, our server costs are going to be more substantial. So we've
      set up a way that you can contribute, and in return, get guaranteed
      uptime.
    </p>
    <h3>
      If I don't get guaranteed uptime, how long will it be until my node
      sleeps?
    </h3>
    <p>
      Unfortunately we don't have a great answer for this question. (Sorry.){" "}
    </p>{" "}
    <p>
      This is why: Rizful Node is mission-driven to expand Lightning adoption.
      We're not doing this to "make money." We would like to keep everyone's
      node online 24/7, even those who don't pay for guaranteed uptime. The
      "guaranteed uptime" feature is actually a <em>safety</em> mechanism for
      us, in the case that we suddenly get a rush of hundreds (or thousands...)
      of new nodes starting up. If this happens, in order to prevent our systems
      being overwhelmed, we will need to prioritize the nodes that have paid for
      guaranteed uptime, so that we can keep the lights on for everyone.
    </p>
    <p>
      And one more detail. If you have NOT paid for "guaranteed uptime", your
      node is <em>less likely</em> to sleep if you are consistently sending and
      recieving payments (even very small zaps) with it. And by consistently, we
      mean several times per week.
    </p>
    <p>
      {" "}
      Apologies that this is so vague. We need to keep it a bit vague in order
      to ensure that we don't make promises that we can't keep. BUT: if you want
      to be <strong>sure</strong> that your Rizful node is going to run 24/7....
      start with this button near the bottom of your screen:
    </p>
    <DocsButton
      ariaLabel="get uptime"
      text="Get Uptime"
      leftSection={<IconClock />}
    />
    <p>
      Click that button, and you'll see a warning that you don't yet have
      guaranteed uptime...
    </p>
    <SimpleImage
      h={300}
      src="docs_images/get-uptime-this-node-will-sleep.png"
    />
    <p>Click the "get uptime" button there, and then....</p>
    <SimpleImage h={650} src="docs_images/activate-guaranteed-uptime.png" />
    <p>
      {" "}
      Perhaps not the world's most attractive menu, but a menu nonetheless.
      These prices will most certainly change in the future, but this is what
      they are right now that we're writing the documentation. You can see that
      if you pay for more upfront, you get a better deal. Nice.
    </p>
    <p> When you're ready to do it, click "Proceed", and... </p>
    <SimpleImage
      h={500}
      src="docs_images/pay-invoice-to-keep-node-running2.png"
    />
    <p>
      Here you can pay an invoice, using your lightning-enabled wallet of
      choice. Once you do that, you'll be sent back to the "nodes" page, and
      you'll see that your node now has an amount of guaranteed uptime.
    </p>
    <SimpleImage h={250} src="docs_images/now-have-uptime-guarantee2.png" />
    <p>
      {" "}
      If you want to extend your uptime, you can do that at any time with the
      [extend] link.
    </p>
  </TypographyStylesProvider>
);
